"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateAddressResponseToJSON = exports.ValidateAddressResponseFromJSONTyped = exports.ValidateAddressResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ValidateAddressResponseFromJSON(json) {
    return ValidateAddressResponseFromJSONTyped(json, false);
}
exports.ValidateAddressResponseFromJSON = ValidateAddressResponseFromJSON;
function ValidateAddressResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': json['success'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
        'inlineErrors': !(0, runtime_1.exists)(json, 'inlineErrors') ? undefined : (0, _1.AddressInlineErrorMessagesFromJSON)(json['inlineErrors']),
        'address': !(0, runtime_1.exists)(json, 'address') ? undefined : (0, _1.AddressOnlyFromJSON)(json['address']),
        'addressOptions': !(0, runtime_1.exists)(json, 'addressOptions') ? undefined : (json['addressOptions'].map(_1.AddressOnlyFromJSON)),
    };
}
exports.ValidateAddressResponseFromJSONTyped = ValidateAddressResponseFromJSONTyped;
function ValidateAddressResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
        'inlineErrors': (0, _1.AddressInlineErrorMessagesToJSON)(value.inlineErrors),
        'address': (0, _1.AddressOnlyToJSON)(value.address),
        'addressOptions': value.addressOptions === undefined ? undefined : (value.addressOptions.map(_1.AddressOnlyToJSON)),
    };
}
exports.ValidateAddressResponseToJSON = ValidateAddressResponseToJSON;
//# sourceMappingURL=ValidateAddressResponse.js.map